import React from 'react';
import {
  components as DefaultSelectComponents,
  IndicatorsContainerProps,
} from 'react-select';
import classNames from 'classnames';
import styles from '../Select.module.scss';

interface Props {
  selectProps: {
    // An extra caller-supplied indicator (e.g. AiFieldAssist's icon+popover),
    // rendered in the innermost slot (closest to the control's edge). The
    // built-in dropdown/error/clear indicators shift outward to make room —
    // see .indicatorsContainerWithRightAdornment in Select.module.scss —
    // rather than the adornment moving around them.
    rightAdornment?: React.ReactNode;
  };
}

function IndicatorsContainer(
  props: IndicatorsContainerProps & Props,
): React.ReactElement {
  const { children, selectProps } = props;
  const { rightAdornment } = selectProps;
  return (
    // @ts-ignore
    <DefaultSelectComponents.IndicatorsContainer
      {...props}
      className={classNames(styles.indicatorsContainer, {
        [styles.indicatorsContainerWithRightAdornment]: !!rightAdornment,
      })}
    >
      {children}
      {rightAdornment && (
        <div className={styles.rightAdornmentWrap}>{rightAdornment}</div>
      )}
    </DefaultSelectComponents.IndicatorsContainer>
  );
}

export default IndicatorsContainer;
